// import stringToHTML helper functions
import { stringToHTML } from 'utilities';

import { Collapse } from 'bootstrap';

// import section style
import './style.scss';

// import template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Add navbar to body
document.body.append(_template_content);

// Scrolled action
scrolledHelper(document.querySelector('nav.navbar'));

// Close mobile menu on mousedown dismiss
mobileMenuDismiss(document.querySelector('nav.navbar'));

// Activate scrollspy
initScrollSpy([
  'Home',
  'AboutUs',
  'Services',
  'EnvironmentSustainability',
  'Partners',
  'Branches',
  'ContactUs',
]);

// Helper function to active scrolled state
function scrolledHelper(navbar_content) {
  window.addEventListener('scroll', function () {
    // Add scrolled class if paged scrolled from beginning to above 300 px.
    if (window.scrollY > 1) {
      // Set scrolled class to nav bar
      navbar_content.classList.add('scrolled');
    } else {
      // Clear scrolled class from nav bar
      navbar_content.classList.remove('scrolled');
    }
  });
}

// Helper function to hide mobile menu on mousedown dismiss
function mobileMenuDismiss(navbar_content) {
  document.addEventListener('mousedown', function (event) {
    const menu = navbar_content.querySelector('.navbar-collapse');
    const isClickInsideMenu = menu.contains(event.target);

    if (!isClickInsideMenu) {
      const bsCollapse = new Collapse(menu, { toggle: false });
      bsCollapse.hide();
    }
  });
}

// Helper function to activate scrollspy
function initScrollSpy(ids) {
  if (!Array.isArray(ids)) {
    console.error('Input must be an array of IDs.');
    return;
  }

  // Cache anchor elements for the IDs
  const anchors = ids.reduce((map, id) => {
    const anchor = _template_content.querySelector(`a[href="#${id}"]`);
    if (anchor) map[id] = anchor;
    else console.warn(`No anchor found for ID: ${id}`);
    return map;
  }, {});

  // Function to determine and update the active section
  function updateActiveSection() {
    let activeId = null;

    // Check each section to see if it's in view
    ids.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        const rect = section.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom > window.innerHeight / 2
        ) {
          activeId = id;
        }
      }
    });

    // Update classes
    Object.keys(anchors).forEach((id) => {
      if (id === activeId) {
        anchors[id].classList.add('show');
      } else {
        anchors[id].classList.remove('show');
      }
    });
  }

  // Run the update once during initialization
  updateActiveSection();

  // Attach scroll event listener
  window.addEventListener('scroll', updateActiveSection);
}
